module.exports = __webpack_public_path__ + "img/exp.2da65aca.png";